import { render, staticRenderFns } from "./PlayerItem.vue?vue&type=template&id=06ce24ba&scoped=true&"
import script from "./PlayerItem.vue?vue&type=script&lang=js&"
export * from "./PlayerItem.vue?vue&type=script&lang=js&"
import style0 from "./PlayerItem.vue?vue&type=style&index=0&id=06ce24ba&prod&lang=scss&scoped=true&"
import style1 from "./PlayerItem.vue?vue&type=style&index=1&id=06ce24ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce24ba",
  null
  
)

export default component.exports